import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=6be8ddee&scoped=true"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"
import style0 from "./Window.vue?vue&type=style&index=0&id=6be8ddee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be8ddee",
  null
  
)

export default component.exports